module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_18_2.01035d07.jpeg";